import { render } from "./chatMessageList.vue?vue&type=template&id=50fdd244&scoped=true&ts=true"
import script from "./chatMessageList.vue?vue&type=script&lang=ts"
export * from "./chatMessageList.vue?vue&type=script&lang=ts"

import "./chatMessageList.vue?vue&type=style&index=0&id=50fdd244&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50fdd244"]])

export default __exports__